import { getBreadcrumbParentsFromState } from './breadcrumbNavigation';

export const DETAIL_RETURN_TO_STATE_KEY = 'returnTo';

/**
 * @param {object} [baseState]
 * @param {string} [returnTo] pathname + search for the screen that opened this detail view
 */
export function buildDetailNavigationState(baseState = {}, returnTo) {
  if (!returnTo) return baseState;
  return {
    ...baseState,
    [DETAIL_RETURN_TO_STATE_KEY]: returnTo,
  };
}

/**
 * Resolves where a detail page back arrow should navigate.
 * @param {import('react-router').Location['state']} locationState
 * @param {string} defaultPath
 * @returns {{ path: string | null, state?: object, useHistoryBack?: boolean }}
 */
export function resolveDetailBackTarget(locationState, defaultPath) {
  const returnTo = locationState?.[DETAIL_RETURN_TO_STATE_KEY];
  if (typeof returnTo === 'string' && returnTo.startsWith('/')) {
    return { path: returnTo };
  }

  const parents = getBreadcrumbParentsFromState(locationState);
  if (parents.length > 0) {
    const last = parents[parents.length - 1];
    if (last?.link) {
      return { path: last.link, state: last.state };
    }
  }

  if (typeof window !== 'undefined' && window.history.length > 1) {
    return { path: null, useHistoryBack: true };
  }

  return { path: defaultPath };
}
